<template>
  <div>
    <transition-group name="fade" mode="out-in">
    <eft v-if="isEFTPopup" @close="closePopup" :orderNumber="orderDetails.orderNumber" key="1"/>
      <div class="fixed_popup" v-else key="2">
      <div class="row m-0 mt-4 h-100 justify-content-center align-items-center" @click.self="closePopup">
        <div class="col-12 col-sm-9 col-md-7 col-lg-5 col-xl-4">
          <div @click="closePopup" class="close_icon">
            <ios-close-icon />
          </div>
          <div class="card p-3">
            <h3>Payment Details</h3>
            <div class="form-group mt-1">
              <radio v-for="method in shopDetails.payment.paymentMethods" v-model="orderDetails.details.paymentMethod" :key="method" :val="method">{{ method | formatPaymentMethod }}</radio>
            </div>
            <div class="row m-0 ">
              <div class="col-12 p-0 mt-2" v-if="orderDetails.details.shippingMethod === 'Delivery' && orderDetails.details.shippingAddress">
                <h5>Delivery R {{ orderDetails.details.deliveryFee }}</h5>
              </div>
              <div class="col-12 p-0 mt-2 mb-3">
                <h2>Total R {{ orderDetails.details.totalCost }}</h2>
              </div>
              <div class="col-12 p-0 mb-2">
                <button class="btn btn-outline w-100" @click="payment">
                  <span class="text-nowrap" id="checkoutButton">Pay </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['orderDetails'],
  components: {
    Radio: () => import('@/components/common/Radio.vue'),
    Eft: () => import('@/components/payment/EFTPopup.vue')
  },
  data () {
    return {
      isEFTPopup: false,
      user_id: '',
      payment_method: 'cc',
      m_payment_id: '',
      signature: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'shopDetails'
    ])
  },
  methods: {
    ...mapActions([
      'addMessage',
      'saveToTransaction',
      'clearCart',
      'addPaymentDetails',
      'updatePaymentMethod'
    ]),
    ccpayment () {
      const yoco = new window.YocoSDK({
        publicKey: process.env.NODE_ENV === 'production' ? this.shopDetails.payment.yoco.publicKey : 'pk_test_7cd9ad03BGZAkjK0e8d4'
      })
      yoco.showPopup({
        amountInCents: this.orderDetails.details.totalCost * 100,
        currency: 'ZAR',
        name: `${this.shopDetails.name}`,
        description: `Order from ${this.shopDetails.name}`,
        callback: this.paymentCallback,
        customer: {
          email: this.currentUser.email,
          firstName: this.currentUser.firstname,
          lastName: this.currentUser.lastname,
          phone: this.currentUser.phone
        },
        metadata: {
          billNote: `order ${this.orderDetails['.key']}`,
          orderId: this.orderDetails['.key'],
          customerId: this.currentUser.uid,
          productType: 'theHoods'
        }
      })
    },
    paymentCallback (result) {
      if (result.errorType) {
        // set order payment to error
        console.log('payment error')
        alert('There was an error with your payment, please try again.')
        // redirect to order?
      } else {
        this.addPaymentDetails({
          uid: this.currentUser.uid,
          token: result,
          orderId: this.orderDetails['.key'],
          amountInCents: this.orderDetails.details.totalCost * 100
        }).then(() => {
          this.$emit('closePay')
        })
      }
    },
    closePopup () {
      this.$emit('closePay')
    },
    payment () {
      this.updatePaymentMethod(this.orderDetails).then(() => {
        if (this.orderDetails.details.paymentMethod === 'Credit Card') {
          this.ccpayment()
        } else if (this.orderDetails.details.paymentMethod === 'EFT') {
          this.isEFTPopup = true
        } else {
          this.$emit('closePay')
        }
      })
    }
  }
}
</script>
<style scoped>
.fixed_popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
}
.close_icon {
  position: absolute;
  right: 15px;
  top: 0;
  text-align: right;
  color: var(--dark-color);
  z-index: 9;
  cursor: pointer;
}
.dark-mode .close_icon {
  color: var(--light-color);
}
</style>
